module.exports = __webpack_public_path__ + "static/media/news-lab-report-jan24.18e511c1.png";